import React from "react";
//import trophy1 from "/data/appData/appImages/trophy/trophy1.jpg"
import './page_1.css'
function Page_1(){
    return(
        <div className="page_1_content" >
            <div className="page_1_content_marge page_1_content_marge_resp" >

                <img className="page_1_tophy1_img" src={"/data/appData/appImages/trophy/trophy1.jpg"} alt=""></img>
            </div>
            
        </div>
    )

}

export default Page_1